module.exports = __webpack_public_path__ + "static/media/2.8ea67913.jpg";